export default function getConfig() {
  const config = process.env.REACT_APP_CONFIG;

  if (!config) {
    /* eslint-disable-next-line no-console */
    console.warn('Please check that your variables are declared on the ".env" file');
  }

  return JSON.parse(config || '{}');
}
